import { createSlice } from '@reduxjs/toolkit';

import {
    FETCH_CREDENTIALS,
    FETCH_CREDENTIALS_FAILURE,
    FETCH_CREDENTIALS_SUCCESS,
    FETCH_PROVIDERS,
    FETCH_PROVIDERS_FAILURE,
    FETCH_PROVIDERS_SUCCESS,
    RESET,
} from './actionTypes';

const INITIAL_STATE = {
    credentials: { data: [], errors: null, isFetching: false },
    providers: { data: [], errors: null, isFetching: false },
};

const credentialIntegrationsSlice = createSlice({
    name: 'credentialIntegrations',
    initialState: INITIAL_STATE,
    reducers: {
        [FETCH_CREDENTIALS]: (state) => {
            state.credentials.errors = null;
            state.credentials.isFetching = true;
        },
        [FETCH_CREDENTIALS_FAILURE]: (state, action) => {
            state.credentials.errors = action.payload;
            state.credentials.isFetching = false;
        },
        [FETCH_CREDENTIALS_SUCCESS]: (state, action) => {
            state.credentials.data = action.payload;
            state.credentials.isFetching = false;
        },
        [FETCH_PROVIDERS]: (state) => {
            state.providers.errors = null;
            state.providers.isFetching = true;
        },
        [FETCH_PROVIDERS_FAILURE]: (state, action) => {
            state.providers.errors = action.payload;
            state.providers.isFetching = false;
        },
        [FETCH_PROVIDERS_SUCCESS]: (state, action) => {
            state.providers.data = action.payload;
            state.providers.isFetching = false;
        },
        [RESET]: () => INITIAL_STATE,
    },
});

export const credentialIntegrationsActions =
    credentialIntegrationsSlice.actions;

export default credentialIntegrationsSlice.reducer;
